import { takeLatest, put, select } from 'redux-saga/effects';
import {
  GAME_SCROLL_SAVE_REQUEST,
  GAME_SCROLL_SAVE_SUCCESS,
  GAME_SCROLL_USE_REQUEST,
  GAME_SCROLL_CLEAR,
  GAME_TABS_REQUEST,
  GAME_TABS_SUCCESS,
  GAME_CLASS_APPS_REQUEST,
  GAME_CLASS_APPS_SUCCESS,
  GAME_CLASS_LIST_SUCCESS,
  GAME_CLASS_LIST_REQURST,
  GAME_ERROR,
  GAME_RANKS_TAB_SUCCESS,
  GAME_RANKS_TAB_REQUEST,
  GAME_RANKS_MORE_LIST_REQUEST,
  GAME_RANKS_MORE_LIST_SUCCESS,
  GET_GAME_CATEGORY_TAG,
  SET_GAME_CATEGORY_TAG,
  GET_SEARCH_TAG,
  SET_SEARCH_TAG,
  GET_TAG_APP_LIST,
  SET_LIST_LOADING,
  SET_TAG_APP_LIST,
  GAME_EXT_SCREEN_REQUEST,
  GAME_EXT_SCREEN_SUCCESS,
} from '../constants/game';
import {
  GAME_TABS,
  GAME_CLASS_APPS_LIST,
  GAME_CLASSES,
  GAME_RANKS,
  GAME_RANK_MORE,
  GAME_CATEGORY_TAG_86,
  GAME_EXT_SCREEN_86,
  GET_SEARCH_TAG_86,
  GET_APP_LIST_86,
} from '../config';
import { createAxios, logNative } from '../utils/utils';

function* scrollSave() {
  let at = 0;
  let scroller = document.querySelector('#game_content');
  if (scroller) {
    at = scroller.scrollTop;
  }

  yield put({
    type: GAME_SCROLL_SAVE_SUCCESS,
    at,
  });
}

function* scrollUse({ action }) {
  let at = yield select(state => state.game.at);
  if (action === 'POP') {
    yield put({
      type: GAME_SCROLL_CLEAR,
    });
  } else {
    at = 0;
  }
  const scroller = document.querySelector('#game_content');
  if (scroller) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scroller.scrollTop = at;
      });
    });
  }
}

export function* watchGameScrollSave() {
  yield takeLatest(GAME_SCROLL_SAVE_REQUEST, scrollSave);
}

export function* watchGameScrollUse() {
  yield takeLatest(GAME_SCROLL_USE_REQUEST, scrollUse);
}

function* fetchGameTabs({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(GAME_TABS, { params: payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: GAME_TABS_SUCCESS,
        menu: res.data.data || [],
      });
    } else {
      yield put({
        type: GAME_ERROR,
        error: true,
      });
    }
  } catch (err) {
    yield put({
      type: GAME_ERROR,
      error: true,
    });
    logNative(JSON.stringify(err));
  }
}

export function* watchFetchGameTabs() {
  yield takeLatest(GAME_TABS_REQUEST, fetchGameTabs);
}

function* fetchGameClassApp({ payload }) {
  const axios = yield createAxios();
  yield put({
    type: GAME_CLASS_APPS_SUCCESS,
    appList: {
      refresh: false,
      loading: true,
    },
  });
  const res = yield axios.get(GAME_CLASS_APPS_LIST, { params: payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: GAME_CLASS_APPS_SUCCESS,
        appList: {
          ...res.data.data,
          ...payload,
          loading: false,
        },
      });
    } else {
      yield put({
        type: GAME_ERROR,
        error: true,
      });
    }
  } catch (err) {
    yield put({
      type: GAME_CLASS_APPS_SUCCESS,
      appList: {
        refresh: false,
        loading: true,
      },
    });
    yield put({
      type: GAME_ERROR,
      error: true,
    });
    logNative(JSON.stringify(err));
  }
}

export function* watchFetchGameClassApp() {
  yield takeLatest(GAME_CLASS_APPS_REQUEST, fetchGameClassApp);
}

function* fetchGameClassList({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(GAME_CLASSES, { params: payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: GAME_CLASS_LIST_SUCCESS,
        classList: res.data.data || [],
      });
    } else {
      yield put({
        type: GAME_ERROR,
        error: true,
      });
    }
  } catch (err) {
    yield put({
      type: GAME_ERROR,
      error: true,
    });
    logNative(JSON.stringify(err));
  }
}

export function* watchFetchGameClass() {
  yield takeLatest(GAME_CLASS_LIST_REQURST, fetchGameClassList);
}

// 获取榜单页面标签
function* fetchGameRankTabs({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(GAME_RANKS, { params: payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: GAME_RANKS_TAB_SUCCESS,
        rankTabList: res.data.data || [],
      });
    } else {
      yield put({
        type: GAME_ERROR,
        error: true,
      });
    }
  } catch (err) {
    yield put({
      type: GAME_ERROR,
      error: true,
    });
    logNative(JSON.stringify(err));
  }
}

export function* watchFetchGameRankTabs() {
  yield takeLatest(GAME_RANKS_TAB_REQUEST, fetchGameRankTabs);
}

// 获取榜单页面更多列表
function* fetchGameRankMoreList({ payload }) {
  yield put({
    type: GAME_RANKS_MORE_LIST_SUCCESS,
    rankMoreList: {
      loading: true,
      ...payload,
    },
  });
  const axios = yield createAxios();
  const res = yield axios.get(GAME_RANK_MORE, { params: payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: GAME_RANKS_MORE_LIST_SUCCESS,
        rankMoreList: {
          loading: false,
          ...payload,
          list: (res.data.data && res.data.data.apps) || [],
          count: res.data.data && res.data.data.count,
          desc: res.data.data && res.data.data.desc,
        },
      });
    } else {
      yield put({
        type: GAME_RANKS_MORE_LIST_SUCCESS,
        rankMoreList: {
          loading: true,
          ...payload,
        },
      });
      yield put({
        type: GAME_ERROR,
        error: true,
      });
    }
  } catch (err) {
    yield put({
      type: GAME_RANKS_MORE_LIST_SUCCESS,
      rankMoreList: {
        loading: true,
        ...payload,
      },
    });
    yield put({
      type: GAME_ERROR,
      error: true,
    });
    logNative(JSON.stringify(err));
  }
}

export function* watchFetchGameRankMoreList() {
  yield takeLatest(GAME_RANKS_MORE_LIST_REQUEST, fetchGameRankMoreList);
}

function* fatchGameCategory({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(GAME_CATEGORY_TAG_86, { params: payload });

  try {
    if (res && res.data.status === 0) {
      let arr = res.data.data.map(item => {
        if (item.pcGameTagList) {
          return {
            ...item,
            pcGameTagList: item.pcGameTagList.map(k => {
              return {
                ...k,
                tags: k.tags.map(t => {
                  return { ...t, tagSelect: 0 };
                }),
              };
            }),
          };
        } else {
          return {
            ...item,
            childClassList: item.childClassList.map(j => {
              return { ...j, tagSelect: 0 };
            }),
          };
        }
      });
      yield put({
        type: SET_GAME_CATEGORY_TAG,
        ...payload,
        list: arr,
        code: res.data.data[0].code,
      });
    }
  } catch (e) {
    logNative(JSON.stringify(e));
  }
}

export function* watchFetchGameCategoryTag() {
  yield takeLatest(GET_GAME_CATEGORY_TAG, fatchGameCategory);
}

// 获取标签筛选结果
function* fetchGetSearchTag({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.post(GET_SEARCH_TAG_86, { tagName: payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: SET_SEARCH_TAG,
        ...payload,
        data: res.data.data,
      });
    }
  } catch (err) {
    logNative(JSON.stringify(err));
  }
}

export function* watchFetchGetSearchTag() {
  yield takeLatest(GET_SEARCH_TAG, fetchGetSearchTag);
}

// 获取游戏库游戏
function* fetchGetAppList({ payload }) {
  if (payload.refresh) {
    yield put({
      type: SET_LIST_LOADING,
      payload: true,
    });
  }
  const axios = yield createAxios();
  const res = yield axios.post(GET_APP_LIST_86, { ...payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: SET_TAG_APP_LIST,
        data: res.data.data,
        ...payload,
      });
      yield put({
        type: SET_LIST_LOADING,
        gameListLoading: false,
      });
    }
  } catch (err) {
    yield put({
      type: SET_LIST_LOADING,
      gameListLoading: false,
    });
    logNative(JSON.stringify(err));
  }
}

export function* watchFetchGetGameAppList() {
  yield takeLatest(GET_TAG_APP_LIST, fetchGetAppList);
}

// 8.6游戏频道 负一屏
function* fetchGameExtScreen({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(GAME_EXT_SCREEN_86, { params: payload });
  try {
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: GAME_EXT_SCREEN_SUCCESS,
        gameExtScreen: { ...res.data, loading: true },
      });
    } else {
      yield put({
        type: GAME_EXT_SCREEN_SUCCESS,
        gameExtScreen: { ...res.data, loading: true },
      });
    }
  } catch (err) {
    yield put({
      type: GAME_EXT_SCREEN_SUCCESS,
      gameExtScreen: { loading: true },
    });
    logNative(JSON.stringify(err));
  }
}
export function* watchFetchGameExtScreen() {
  yield takeLatest(GAME_EXT_SCREEN_REQUEST, fetchGameExtScreen);
}
